import AxiosConfig from '@/config/axios-config'
import Constants from '@/core/constants/constants'

export const ConteudoAPI = {

  listarModalidades () {
    return AxiosConfig.secureJalekoAPI().get('/admin/modalidades').then(response => response.data)
  },

  listarFontes () {
    return AxiosConfig.secureJalekoAPI().get('/admin/fontes').then(response => response.data)
  },

  listarPublicos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/publicos').then(response => response.data)
  },

  listarTiposFontes () {
    return AxiosConfig.secureJalekoAPI().get('/admin/tipo-fonte').then(response => response.data)
  },

  editarPublico (params) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/publicos/${params.id}`, params).then(response => response.data)
  },

  editarModalidade (params) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/modalidades/${params.id}`, params).then(response => response.data)
  },

  editarFonte (params) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/fontes/${params.id}`, params).then(response => response.data)
  },

  editarTipoSimulado (params) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/simulados/tipo/${params.id}`, params).then(response => response.data)
  },

  cadastrarPublico (params) {
    return AxiosConfig.secureJalekoAPI().post('/admin/publicos', params).then(response => response.data)
  },

  cadastrarModalidade (params) {
    return AxiosConfig.secureJalekoAPI().post('/admin/modalidades', params).then(response => response.data)
  },

  cadastrarFonte (params) {
    return AxiosConfig.secureJalekoAPI().post('/admin/fontes', params).then(response => response.data)
  },

  cadastrarTipoSimulado (params) {
    return AxiosConfig.secureJalekoAPI().post('/admin/simulados/tipo', params).then(response => response.data)
  },

  excluirPublico (id) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/publicos/${id}`).then(response => response.data)
  },

  excluirModalidade (id) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/modalidades/${id}`).then(response => response.data)
  },

  excluirFonte (id) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/fontes/${id}`).then(response => response.data)
  },

  excluirTipoSimulado (id) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/simulados/tipo/${id}`).then(response => response.data)
  },

  editarTipo (params, tipoClassificacao) {
    let param
    let tipo = parseInt(tipoClassificacao)
    switch (tipo) {
      case Constants.PUBLICO_ALVO:
        param = {
          id: params.id,
          publico: params.descricao,
          sigla: params.nome
        }
        return this.editarPublico(param)
      case Constants.MODALIDADE:
        param = {
          id: params.id,
          descricao: params.descricao,
          modalidade: params.nome,
          fonte_id: params.fonteId,
          publico_id: params.publicoId
        }
        return this.editarModalidade(param)
      case Constants.FONTE:
        param = {
          id: params.id,
          descricao: params.descricao,
          fonte: params.nome,
          tipo_fonte_id: params.tipoFonteId
        }
        return this.editarFonte(param)
      case Constants.TIPO_SIMULADO:
        param = {
          id: params.id,
          descricao: params.descricao
        }
        return this.editarTipoSimulado(param)
      default:
        break
    }
  },

  cadastrarTipo (params, tipoClassificacao) {
    let param
    let tipo = parseInt(tipoClassificacao)
    switch (tipo) {
      case Constants.PUBLICO_ALVO:
        param = {
          id: params.id,
          publico: params.descricao,
          sigla: params.nome
        }
        return this.cadastrarPublico(param)
      case Constants.MODALIDADE:
        param = {
          id: params.id,
          descricao: params.descricao,
          modalidade: params.nome,
          fonte_id: params.fonteId,
          publico_id: params.publicoId
        }
        return this.cadastrarModalidade(param)
      case Constants.FONTE:
        param = {
          id: params.id,
          descricao: params.descricao,
          fonte: params.nome,
          tipo_fonte_id: params.tipoFonteId
        }
        return this.cadastrarFonte(param)
      case Constants.TIPO_SIMULADO:
        param = {
          id: params.id,
          descricao: params.descricao
        }
        return this.cadastrarTipoSimulado(param)
      default:
        break
    }
  },
  excluirTipo (id, tipoClassificacao) {
    let tipo = parseInt(tipoClassificacao)
    switch (tipo) {
      case Constants.PUBLICO_ALVO:
        return this.excluirPublico(id)
      case Constants.MODALIDADE:
        return this.excluirModalidade(id)
      case Constants.FONTE:
        return this.excluirFonte(id)
      case Constants.TIPO_SIMULADO:
        return this.excluirTipoSimulado(id)
      default:
        break
    }
  }

}

export default ConteudoAPI
